/**
 * Card tiers mapped to holo effects. Mirrors `PioneerCardType` in the
 * pioneer-event app's pioneerApi (same string union — structurally compatible)
 * without depending on the app-specific API module.
 */
export type HoloCardTier = "base" | "holo" | "blue_sapphire" | "gold_vinyl" | "patch_5" | "patch_1";

/** Holo effect tiers rendered by PioneerHoloCard (styles in ../styles/holo/holo.css). */
export type PioneerHoloEffect = "basic" | "rainbow-holo" | "radiant-holo" | "hyper-rare";

export function cardHoloEffect(cardType: HoloCardTier): PioneerHoloEffect {
  if (cardType === "patch_1" || cardType === "patch_5" || cardType === "gold_vinyl") {
    return "hyper-rare";
  }
  if (cardType === "blue_sapphire") return "radiant-holo";
  if (cardType === "holo") return "rainbow-holo";
  return "basic";
}

export type PioneerHoloMotion = {
  initialOpacity: number;
  tiltDivisor: number;
};

export function cardHoloMotion(effect: PioneerHoloEffect): PioneerHoloMotion {
  if (effect === "hyper-rare") {
    return { initialOpacity: 0.58, tiltDivisor: 2.35 };
  }
  if (effect === "radiant-holo") {
    return { initialOpacity: 0.48, tiltDivisor: 3.1 };
  }
  if (effect === "rainbow-holo") {
    return { initialOpacity: 0.32, tiltDivisor: 3.4 };
  }
  return { initialOpacity: 0.3, tiltDivisor: 3.7 };
}
